import {
  MODULE_NAME,
  MOUNT,
  UNMOUNT,
  CLEAR_PROJECT_ROLE,
  CLEAR_PROJECT_ID,
  CHANGE_PROJECT_ROLE,
  CHANGE_PROJECT_ROLE_START,
  CHANGE_PROJECT_ROLE_SUCCESS,
  UPDATE_PROJECT_ROLE,
  UPDATE_ROLE_STATUS,
  UPDATE_PROJECT_ID,
  FETCH_PROJECT_PERMISSION,
  FETCH_PROJECT_PERMISSION_START,
  FETCH_PROJECT_PERMISSION_SUCCESS,
  FETCH_PROJECT_PERMISSION_ERROR,
} from './constants'

const clearProjectRole = () => ({ type: CLEAR_PROJECT_ROLE })
const updateProjectRole = (roles) => ({ type: UPDATE_PROJECT_ROLE, roles })
const changeProjectRole = (roles) => ({ type: CHANGE_PROJECT_ROLE, roles })
const changeProjectRoleStart = () => ({ type: CHANGE_PROJECT_ROLE_START })
const changeProjectRoleSuccess = () => ({ type: CHANGE_PROJECT_ROLE_SUCCESS })

const enableRoleStatus = () => ({ type: UPDATE_ROLE_STATUS, enable: true })
const disableRoleStatus = () => ({ type: UPDATE_ROLE_STATUS, enable: false })

const updateProjectId = (id) => ({ type: UPDATE_PROJECT_ID, id })
const clearProjectId = () => ({ type: CLEAR_PROJECT_ID })

const mount = (projectId) => ({ type: MOUNT, projectId })
const unmount = () => ({ type: UNMOUNT })

const fetchProjectPermission = (projectId) => ({ type: FETCH_PROJECT_PERMISSION, projectId })
const fetchProjectPermissionStart = () => ({ type: FETCH_PROJECT_PERMISSION_START })
const fetchProjectPermissionSuccess = (permission) => ({ type: FETCH_PROJECT_PERMISSION_SUCCESS, permission })
const fetchProjectPermissionError = (error) => ({ type: FETCH_PROJECT_PERMISSION_ERROR, error })

export {
  clearProjectRole,
  clearProjectId,
  updateProjectRole,
  changeProjectRole,
  changeProjectRoleStart,
  changeProjectRoleSuccess,
  enableRoleStatus,
  disableRoleStatus,
  mount,
  unmount,
  updateProjectId,
  fetchProjectPermission,
  fetchProjectPermissionStart,
  fetchProjectPermissionSuccess,
  fetchProjectPermissionError,
}
